var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "h2",
      { class: _vm.$style.title },
      [
        _vm._t("default"),
        _vm.required || _vm.optional
          ? _c(
              "div",
              { class: _vm.$style.badge },
              [
                _vm.required
                  ? _c("Badge", { attrs: { text: "必填" } })
                  : _vm.optional
                  ? _c("Badge", { attrs: { text: "選填", disabled: "" } })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ],
      2
    ),
    _c("div", { class: _vm.$style.text }, [_vm._t("text")], 2),
    !_vm.noUnderline ? _c("div", { class: _vm.$style.line }) : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }